module.exports = __webpack_public_path__ + "static/media/managers.3290c6bc.svg";